// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: max-content;
  margin: 0 auto;
  gap: 10px;
}
.footer-lang div {
  text-align: center;
  border: 0.5px solid var(--ion-color-primary);
  background: #fff;
  border-radius: var(--radius-default);
  overflow: hidden;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  gap: 10px;
}
.footer-lang div p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.footer-lang div ion-icon {
  height: 24px;
  width: 24px;
  border: 1px solid var(--ion-color-primary-contrast);
  border-radius: 50px;
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
}
.footer-lang div.selected p {
  color: var(--ion-color-primary-contrast);
}
.footer-lang div.selected ion-icon {
  border: 1px solid var(--ion-color-primary-contrast);
}
.footer-lang div.from_menu.selected {
  background: var(--ion-color-primary);
}
.footer-lang div.from_menu.selected p {
  color: var(--ion-color-primary-contrast);
}`, "",{"version":3,"sources":["webpack://./src/app/components/lang-switcher/lang-switcher.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;;AACA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAED;AAAC;EACC,kBAAA;EACA,4CAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,SAAA;AAEF;AADE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,+BAAA;AAEH;AAAE;EACC,YAAA;EACA,WAAA;EACA,mDAAA;EACA,mBAAA;AAEH;AAEE;EACC,oCAAA;AAAH;AAEG;EACC,wCAAA;AAAJ;AAGG;EACC,mDAAA;AADJ;AAMG;EACC,oCAAA;AAJJ;AAMI;EACC,wCAAA;AAJL","sourcesContent":[":host {\n\tdisplay: block;\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmax-width: max-content;\n\tmargin: 0 auto;\n\tgap: 10px;\n\n\tdiv {\n\t\ttext-align: center;\n\t\tborder: 0.5px solid var(--ion-color-primary);\n\t\tbackground: #fff;\n\t\tborder-radius: var(--radius-default);\n\t\toverflow: hidden;\n\t\tpadding: 10px 16px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\twidth: fit-content;\n\t\tgap: 10px;\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 16px;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t\tion-icon {\n\t\t\theight: 24px;\n\t\t\twidth: 24px;\n\t\t\tborder: 1px solid var(--ion-color-primary-contrast);\n\t\t\tborder-radius: 50px;\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tbackground: var(--ion-color-primary);\n\n\t\t\tp {\n\t\t\t\tcolor: var(--ion-color-primary-contrast);\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tborder: 1px solid var(--ion-color-primary-contrast);\n\t\t\t}\n\t\t}\n\n\t\t&.from_menu {\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\n\t\t\t\tp {\n\t\t\t\t\tcolor: var(--ion-color-primary-contrast);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
